import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGComponent } from '../../../../sb-modules/Frontend-Inline-SVG-Module/inline-svg.component';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-complete-ticket-modal',
    templateUrl: './close-ticket-with-unhandled-replies-modal.component.html',
    styleUrls: ['./close-ticket-with-unhandled-replies-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslateModule, InlineSVGComponent, FormsModule],
})
export class CloseTicketWithUnhandledRepliesModalComponent {
    confirmCallback: (isMarkAsHandled: boolean) => void;
    isMarkAsHandled: boolean;

    constructor(private modalRef: BsModalRef) {}

    closeTicket(): void {
        this.confirmCallback(this.isMarkAsHandled);
        this.modalRef.hide();
    }

    decline(): void {
        this.modalRef.hide();
    }
}
